import React from "react";
class ResizablePanelItem extends React.PureComponent {
}
export default ResizablePanelItem;
